var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJoinCampaign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 631.208,
    height: 626.952,
    viewBox: "0 0 631.208 626.952",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6108",
    "data-name": "Group 6108",
    transform: "translate(-103.688 -44.206)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3099",
    "data-name": "Rectangle 3099",
    width: 96.672,
    height: 465.74,
    rx: 48.336,
    transform: "translate(165.827 417.634) rotate(-130)",
    fill: "#fe6c13"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3100",
    "data-name": "Rectangle 3100",
    width: 96.672,
    height: 609.458,
    rx: 48.336,
    transform: "translate(268.024 511.159) rotate(-130)",
    fill: "#0fa0fc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3102",
    "data-name": "Rectangle 3102",
    width: 96.672,
    height: 609.458,
    rx: 48.336,
    transform: "translate(263.024 671.159) rotate(-130)",
    fill: "#8d2be9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoinCampaign);
export default __webpack_public_path__ + "static/media/join-campaign.691da0c18f59662913e263b475260075.svg";
export { ForwardRef as ReactComponent };